import http from '@admin/http';
import { AxiosInstance } from 'axios';

export function recallAccountCtor(http: AxiosInstance) {
  return async (id: string) => http.put(`/lnpl/v1/delinquent-loan-orders/${id}/recall-account`);
}

export const recallAccount = recallAccountCtor(http);
